export const ICrossSellingListProvider = "ICrossSellingListProvider";
